import { useEffect, useState } from 'react';
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { getAllEmployeesApi } from '../../../../Api/Employee';
import { getBatchByIdApi } from '../../../../Api/Batch';
import { addBatchEmployeeApi } from '../../../../Api/BatchEmployee';
import { TbFilterX } from 'react-icons/tb';
import { VscFilter } from 'react-icons/vsc';
import SideModal from '../../../general/Sidemodal';

type Props = {
    url: string,
    batchId: string,
    assignModal: boolean;
    setAssignModal: React.Dispatch<React.SetStateAction<boolean>>;
};
type User = {
    id: string;
    name: string;
    email: string;
    mobile: string;
    gender: number | null;
    address: string;
    roleType: string;
};
export interface EmployeeInterface {
    id: string;
    userId: string;
    employeeType: string;
    permanentAddress: string;
    isActive: boolean;
    salary: number;
    hourlyRate: number;
    joiningDate: string;
    leavingDate?: string | null;
    updatedBy: string;
    updatedOn: string;
    user: User;
}


const AsignEmployee = ({ url, batchId, assignModal, setAssignModal }: Props) => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState<boolean>(false);
    const [Employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState<{ id: string; hourlyRate: number } | null>(null);
    const [StartTime, setStartTime] = useState("");
    const [EndTime, setEndTime] = useState("");
    const [StartDate, setStartDate] = useState<string | null>(null);
    const [EndDate, setEndDate] = useState<string | null>(null);
    const [hourlyRate, setHourlyRate] = useState<number | undefined>(undefined);
    const [filterModal, setFilterModal] = useState(false);
    const [selectedGender, setSelectedGender] = useState<number | null>(null);
    // Pagination state
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 10;

    const fetchData = async (page: number) => {
        try {
            setLoader(true);
            const response: any = await getAllEmployeesApi(url, page, itemsPerPage, searchTerm, selectedGender);
            setEmployees(response.employees || []);
            setTotalPages(Math.ceil(response.totalCount / itemsPerPage));
        } catch (error) {
            console.error(error);
            toast.error("Failed to fetch data");
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        setHourlyRate(selectedEmployee?.hourlyRate);
    }, [selectedEmployee]);

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage]);

    useEffect(() => {
        const fetchBatchData = async () => {
            if (batchId) {
                try {
                    const batch = await getBatchByIdApi(url, batchId);
                    setHourlyRate(batch.hourlyRate);
                    setStartTime(batch.startTime);
                    setEndTime(batch.endTime);
                } catch (error) {
                    toast.error("Failed to fetch batch details.");
                }
            }
        };

        fetchBatchData();
    }, [batchId]);

    const handleSearchSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setCurrentPage(1);
        fetchData(1);
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
    };
    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    function onSubmitClick(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();
        if (!selectedEmployee) {
            toast.error("Please select an employee.");
            return;
        }
        if (!hourlyRate) {
            toast.error("Please select Hourly Rate.");
            return;
        }
        if (!StartTime || !EndTime) {
            toast.error("Please select both start and end time.");
            return;
        }
        if (!StartDate) {
            toast.error("Please select start date.");
            return;
        }

        addBatchEmployeeApi(url, batchId, selectedEmployee.id, hourlyRate, StartTime, EndTime, StartDate, EndDate)
            .then(() => {
                toast.success("Employee assigned to batch successfully!");
                setAssignModal(false);
            })
            .catch((error) => {
                toast.error("Failed to assign employee. Please try again.");
                console.error(error);
            });
    }

    const applyFilters = () => {
        setCurrentPage(1);
        fetchData(1);
        setFilterModal(false);
    };

    return (
        <div>
            <h1 className="text-2xl md:text-3xl font-bold text-blue-600 mb-4 md:mb-6">
                Assign Batch
            </h1>

            {/* Search Input */}
            <div className='flex flex-row items-center w-full gap-4 justify-between md:justify-start'>
                <form onSubmit={handleSearchSubmit} className="w-full md:flex-grow mb-4">
                    <label
                        htmlFor="default-search"
                        className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                    >
                        Search
                    </label>
                    <div className="relative">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg
                                className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                />
                            </svg>
                        </div>
                        <input
                            type="search"
                            id="default-search"
                            className="w-full p-3 ps-10 outline-none text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Search by Name, Email, Mobile, EmployeeType, Salary"
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                        <button
                            type="submit"
                            className="text-white absolute end-1.5 bottom-1.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                            Search
                        </button>
                    </div>
                </form>
                <div
                    className="flex flex-row gap-1 justify-center px-1 py-2 h-10 w-[90px] hover:bg-gray-100 rounded-md cursor-pointer  mb-4"
                    onClick={() => setFilterModal(true)}
                >
                    <VscFilter className="text-blue-500 h-7 w-7" />
                    <span className="text-lg font-normal text-gray-600">Filter</span>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 md:rounded-lg">
                    <thead className="bg-gray-50 dark:bg-gray-800">
                        <tr>
                            <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Select</th>
                            <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Name</th>
                            <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Mobile</th>
                            <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Hourly Rate</th>
                            <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Joining Date</th>
                            <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Leaving Date</th><th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Email</th>
                            <th className="px-4 py-3.5 text-md font-normal text-left text-gray-500 dark:text-gray-400">Gender</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                        {loader ? (
                            <tr>
                                <td colSpan={13} className="py-3 text-center">
                                    <div className="w-12 h-12 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin mx-auto"></div>
                                </td>
                            </tr>
                        ) : (
                            Employees.map((item) => (
                                <tr key={item.user.id} className="hover:bg-gray-50">
                                    <td className="px-4 py-4 text-sm whitespace-nowrap">
                                        <input
                                            type="radio"
                                            name="batch"
                                            value={item.id}
                                            checked={selectedEmployee?.id === item.id}
                                            onChange={() => setSelectedEmployee({ id: item.id, hourlyRate: item.hourlyRate })}
                                        />
                                    </td>
                                    <td className="px-4 py-4 text-sm font-medium text-gray-700 whitespace-nowrap">{item.user.name}</td>
                                    <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">{item.user.mobile}</td>
                                    <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">₹{item.hourlyRate}</td>
                                    <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">{item.joiningDate}</td>
                                    <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">{item.leavingDate || '-'}</td>
                                    <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">{item.user.email}</td>
                                    <td className="px-4 py-4 text-sm text-gray-500 whitespace-nowrap">
                                        {item.user.gender === 1 ? 'Male' : item.user.gender === 2 ? 'Female' : ''}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination */}
            <div className="flex flex-wrap items-center justify-center md:justify-between mt-6 gap-2 md:gap-4">
                <button
                    disabled={currentPage === 1}
                    onClick={handlePreviousPage}
                    className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 rtl:-scale-x-100"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                        />
                    </svg>
                    <span>Previous</span>
                </button>
                <div className="flex flex-wrap items-center justify-center gap-x-2">
                    {[...Array(Math.max(totalPages, 1))].map((_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => setCurrentPage(index + 1)}
                            className={`px-2 py-1 text-sm ${currentPage === index + 1
                                ? "text-blue-500 bg-blue-100"
                                : "text-gray-500 hover:bg-gray-100"
                                } rounded-md`}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>
                <button
                    disabled={currentPage === totalPages}
                    onClick={handleNextPage}
                    className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
                >
                    <span>Next</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 rtl:-scale-x-100"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                        />
                    </svg>
                </button>
            </div>

            <div className="mt-10">
                <label className="block text-sm font-medium">Hourly Rate<span className="text-red-500">*</span></label>
                <input
                    type="number"
                    value={hourlyRate}
                    onChange={(e) => setHourlyRate(Number(e.target.value))}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder='Hourly Rate'
                    required
                />
            </div>

            <div className="flex justify-between mt-10">
                <div className="w-1/2 pr-2">
                    <label htmlFor="customStartTime" className="block text-sm font-medium text-black dark:text-gray-200 mb-2">
                        Start Time <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="time"
                        id="customStartTime"
                        value={StartTime}
                        onChange={(e) => setStartTime(e.target.value)}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        required
                    />
                </div>
                <div className="w-1/2 pl-2">
                    <label htmlFor="customEndTime" className="block text-sm font-medium text-black dark:text-gray-200 mb-2">
                        End Time <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="time"
                        id="customEndTime"
                        value={EndTime}
                        onChange={(e) => setEndTime(e.target.value)}
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        required
                    />
                </div>
            </div>

            <div className='flex flex-row justify-between mt-10 gap-4 '>
                {/* Start Date */}
                <div className="flex flex-col space-y-2 w-full  ">
                    <label className="text-gray-900 dark:text-gray-200 font-semibold">Start Date<span className="text-red-500">*</span></label>
                    <input
                        required
                        name="StartDate"
                        type="date"
                        value={StartDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Start Date"
                    />
                </div>

                {/* Leaving Date */}
                <div className="flex flex-col space-y-2 w-full ">

                    <label className="text-gray-900 dark:text-gray-200 font-semibold">End Date</label>
                    <input
                        name="leavingDate"
                        type="date"
                        value={EndDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="End Date"
                    />
                </div>
            </div>

            <div className=" flex gap-2 md:gap-4 mt-5">
                <button
                    type='button'
                    className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                    onClick={onSubmitClick}
                >
                    Assign Employee
                </button>

                <button
                    className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide capitalize transition-colors duration-300 transform border border-gray-800  rounded-md hover:bg-gray-200"
                    onClick={() => setAssignModal(false)}
                >
                    Cancel
                </button>
            </div>

            {filterModal && (
                <div className='fixed inset-0 z-50 flex justify-end  bg-gray-900 bg-opacity-50'>
                    <div className='bg-white h-full  w-[70%] dark:bg-gray-800  shadow-lg p-6'>
                        <h1 className="text-2xl md:text-3xl font-bold text-blue-600 mb-4 md:mb-6">
                            Filter
                        </h1>
                        <button
                            onClick={() => setFilterModal(false)}
                            className="absolute top-1 right-3 text-gray-400 hover:text-gray-600 text-2xl"
                        >
                            &times;
                        </button>

                        <div className="mb-4 flex flex-col">
                            <label className="text-base font-semibold text-gray-900 mb-2">Gender</label>
                            <div className="w-full">
                                <select
                                    value={selectedGender}
                                    onChange={(e) => setSelectedGender(e.target.value === "" ? null : Number(e.target.value))}
                                    className="w-full px-4 py-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring"
                                >
                                    <option value="">All</option>
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                </select>
                            </div>
                        </div>

                        <div className=" flex gap-2 md:gap-4">
                            <button
                                type='button'
                                onClick={applyFilters}
                                className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"

                            >
                                Apply
                            </button>
                            <button
                                className="flex items-center justify-center w-fit px-4 py-2 mt-3 font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                                type='button'
                                onClick={() => setFilterModal(false)}
                            >
                                Cancel
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    )
}

export default AsignEmployee